import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Button, Col, Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { CreateConsultantModalWithGlobalContext } from '../Modals/CreateConsultantModal/CreateConsultantModal';
import { CreateProjectModalWithGlobalContext } from '../Modals/CreateProjectModal/CreateProjectModal';
import { LoginModalWithGlobalContext } from '../Modals/LoginModal';
import { ModalPortal } from '../Modals/ModalPortal';
import { ResetPasswordModal } from '../Modals/ResetPasswordModal';
import { SignupConfirmationModalWithGlobalContext } from '../Modals/SignupConfirmationModal';
import { SignupModalWithGlobalContext } from '../Modals/SignupModal';
import { Svg } from '../Svg';
import { LoggedHeaderWithGlobalContext } from './LoggedHeader';

interface IHeaderState {
  createConsultantModalIsOpen: boolean;
  createProjectModalIsOpen: boolean;
  navIsOpen: boolean;
  loginModalIsOpen: boolean;
  resetPasswordModalIsOpen: boolean;
  signupConfirmationModalIsOpen: boolean;
  signupModalIsOpen: boolean;
}

class Header extends React.Component<
  IGlobalContextProps & RouteComponentProps,
  IHeaderState
> {
  public state = {
    createConsultantModalIsOpen: false,
    createProjectModalIsOpen: false,
    loginModalIsOpen: false,
    navIsOpen: false,
    resetPasswordModalIsOpen: false,
    signupConfirmationModalIsOpen: false,
    signupModalIsOpen: false,
  };

  
  public toggleLoginModal = () =>
    this.setState({
      createConsultantModalIsOpen: false,
      createProjectModalIsOpen: false,
      loginModalIsOpen: !this.state.loginModalIsOpen,
      resetPasswordModalIsOpen: false,
      signupModalIsOpen: false,
    });

  public toggleSignupModal = () =>
    this.setState({ signupModalIsOpen: !this.state.signupModalIsOpen });

  public toggleResetPasswordModal = () =>
    this.setState({
      resetPasswordModalIsOpen: !this.state.resetPasswordModalIsOpen,
    });

  public toggleCreateConsultantModal = () =>
    this.setState({
      createConsultantModalIsOpen: !this.state.createConsultantModalIsOpen,
    });

  public toggleCreateProjectModal = () =>
    this.setState({
      createProjectModalIsOpen: !this.state.createProjectModalIsOpen,
    });

  public toggleSignupConfirmationModal = () =>
    this.setState({
      signupConfirmationModalIsOpen: !this.state.signupConfirmationModalIsOpen,
    });


  public async componentDidMount() {
    const { user, updateUser } = this.props.context;
    const { history, location } = this.props;
    if (!user) {
      updateUser();
    }
    const accessTokenExpiration = localStorage.getItem(
      'beadvize-accessTokenExpiration'
    )
      ? parseFloat(localStorage.getItem(
          'beadvize-accessTokenExpiration'
        ) as string)
      : 0;
    if (accessTokenExpiration < Date.now() && location.pathname !== '/') {
      history.push('/');
    }
  }

  public toggle = () =>
  this.setState({ navIsOpen: !this.state.navIsOpen })

  public render() {
    const { context } = this.props;
    const {
      createProjectModalIsOpen,
      createConsultantModalIsOpen,
      loginModalIsOpen,
      navIsOpen,
      resetPasswordModalIsOpen,
      signupConfirmationModalIsOpen,
      signupModalIsOpen,
    } = this.state;

    const IsCreating = localStorage.getItem('beadvize-IsCreating');
  
    return (
      <>
       {context.user && !context.isCreating && !IsCreating ? (
          <LoggedHeaderWithGlobalContext 
            toggle={this.toggle}
            navIsOpen={this.state.navIsOpen}
          />
        ) : (
          <Row
          className='sticky-top d-flex justify-content-center align-items-center bg-white m-0'
          tag='nav'
        >
          <Col className='px-0'>
            <Navbar className='navbar-light' expand="lg"  toggleable={true}>
              <NavbarBrand href="/" className="mr-auto">
                <Link to='/' >
                  <Svg src='logo/logo-color' width={128} height={64} />
                </Link>
              </NavbarBrand>
              <NavbarToggler onClick={this.toggle}  className={`pr-0 ${navIsOpen === false ? 'closed' : 'opened'}`}/>
              <Collapse  isOpen={this.state.navIsOpen} navbar={true}>
                <Nav className="d-flex  w-100" navbar={true}>
                  <NavItem className='d-flex align-items-center justify-content-center mt-2 mb-2 mx-auto'> 
                    <HashLink  smooth={true}  to='/#how-does-it-work'>
                      Comment ça fonctionne
                    </HashLink>
                  </NavItem>
                  <NavItem className='d-flex align-items-center justify-content-center mt-2 mb-2 mx-auto'>
                    <Link to='/'  onClick={this.toggleLoginModal}>Connexion</Link>
                  </NavItem>
                  <NavItem className='mx-auto'>
                    <Button className='text-uppercase text-white bg-success border-0 w-100 mt-2 mb-2 ' onClick={this.toggleCreateProjectModal}>&nbsp;&nbsp;Déposez un projet&nbsp;&nbsp;  </Button>
                  </NavItem >
                  <NavItem className='ml-auto  mr-auto mr-lg-0 '>
                    <Button className='text-uppercase text-white bg-secondary border-0 w-100 mt-2 mb-2' onClick={this.toggleCreateConsultantModal}>Inscription consultant</Button>
                  </NavItem>
                </Nav>
               
              </Collapse>
            </Navbar>
          </Col>
       
        </Row>


/*
          <Row
            className='sticky-top d-flex justify-content-center align-items-center bg-white m-0'
            tag='nav'
            style={{ minHeight: '100px' }}
          >
            <Col md='6' xs='auto'>
              <Row className='d-flex justify-content-center align-item-center'>
                <Col md='4' xs='auto' className='d-flex justify-content-center'>
                  <Link to='/' onClick={this.scrollTop}>
                    <Svg src='logo/logo-color' width={128} height={64} />
                  </Link>
                </Col>
                <Col
                  md='8'
                  xs='auto'
                  className='d-flex justify-content-center align-items-center text-center'
                >
                  <HashLink
                    className='align-middle p-3'
                    smooth={true}
                    to='/#how-does-it-work'
                  >
                    Comment ça fonctionne
                  </HashLink>
                  <Link
                    to='/'
                    className='align-middle p-3'
                    onClick={this.toggleLoginModal}
                  >
                    Connexion
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col
              md='6'
              xs='auto'
              className='d-flex justify-content-center align-items-center'
            >
              <Row className='d-flex justify-content-center align-items-center w-100'>
                <Col md='6' xs='auto'>
                  <Button
                    className='text-uppercase text-white bg-success border-0 w-100 mt-2 mb-2'
                    onClick={this.toggleCreateProjectModal}
                  >
                    Déposez un projet
                  </Button>
                </Col>
                <Col md='6' xs='auto'>
                  <Button
                    className='text-uppercase text-white bg-secondary border-0 w-100 mt-2 mb-2'
                    onClick={this.toggleCreateConsultantModal}
                  >
                    Devenez un consultant
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
*/


        )}
        <ModalPortal>
          <LoginModalWithGlobalContext
            isOpen={loginModalIsOpen}
            toggleLoginModal={this.toggleLoginModal}
            toggleResetPasswordModal={this.toggleResetPasswordModal}
            toggleSignupModal={this.toggleSignupModal}
          />
          <SignupModalWithGlobalContext
            isOpen={signupModalIsOpen}
            toggleLoginModal={this.toggleLoginModal}
            toggleSignupModal={this.toggleSignupModal}
            toggleSignupConfirmationModal={this.toggleSignupConfirmationModal}
          />
          <SignupConfirmationModalWithGlobalContext
            isOpen={signupConfirmationModalIsOpen}
            toggleSignupConfirmationModal={this.toggleSignupConfirmationModal}
          />
          <ResetPasswordModal
            isOpen={resetPasswordModalIsOpen}
            toggleLoginModal={this.toggleLoginModal}
            toggleResetPasswordModal={this.toggleResetPasswordModal}
          />
          <CreateProjectModalWithGlobalContext
            isOpen={createProjectModalIsOpen}
            toggleCreateProjectModal={this.toggleCreateProjectModal}
            toggleLoginModal={this.toggleLoginModal}
            toggleSignupConfirmationModal={this.toggleSignupConfirmationModal}
          />
          <CreateConsultantModalWithGlobalContext
            isOpen={createConsultantModalIsOpen}
            toggleCreateConsultantModal={this.toggleCreateConsultantModal}
            toggleLoginModal={this.toggleLoginModal}
            toggleSignupConfirmationModal={this.toggleSignupConfirmationModal}
          />
        </ModalPortal>
      </>
    );
  }
}

export const HeaderWithGlobalContext = withGlobalContext(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/shared/Header/Header.tsx